import { baseApi } from './baseApi';

const accessoriesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAccessories: build.query({
      query: (queryParameters) => ({
        url: '/accessories/all',
        method: 'GET',
        params: queryParameters,
      }),
      providesTags: ['accessories'],
    }),
    getSingleAccessory: build.query({
      query: (id: string) => ({
        url: `/accessories/${id}`,
        method: 'GET',
      }),
      providesTags: ['accessories'],
    }),
    postAccessory: build.mutation({
      query: (data) => ({
        url: '/accessories/create/',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['accessories'],
    }),
    updateAccessory: build.mutation({
      query: ({ id, data }: { id: string; data: any }) => ({
        url: `/accessories/update/${id}`,
        method: 'PATCH',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['accessories'],
    }),
    deleteAccessory: build.mutation({
      query: (accessoryId) => ({
        url: `/accessories/delete/${accessoryId}`,
        method: 'DELETE',
        credentials: 'include',
      }),
      invalidatesTags: ['accessories'],
    }),
  }),
});

export const {
  useGetAccessoriesQuery,
  useGetSingleAccessoryQuery,
  usePostAccessoryMutation,
  useUpdateAccessoryMutation,
  useDeleteAccessoryMutation,
} = accessoriesApi;
